module.exports = __webpack_public_path__ + "img/mobieScreenFeature1.f8d584a9.svg";